// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._c71lidpf{max-height:0}
._kqswstnw{position:absolute}
._p12fidpf{max-width:0}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/renderer/node_modules/@atlaskit/smart-card/dist/esm/view/common/stop-propagation/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,YAAY;AACvB,WAAW,iBAAiB;AAC5B,WAAW,WAAW","sourcesContent":["._c71lidpf{max-height:0}\n._kqswstnw{position:absolute}\n._p12fidpf{max-width:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
